import { useDispatch } from "react-redux";
import clsx from "clsx";
import { Divider, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { searchHandler } from "../../../reducers/ownApp/thunkActions";

import { LOCATION } from "../../../consts/strings";
import { palette } from "../../../theme/palette";

import { View } from "../../View";
import { BaseSummaryPopover } from "../Base/BaseSummaryPopover";

const useStyles = makeStyles(() => ({
  locationLine: {
    fontWeight: "bold",
    color: palette.typography.black.solid,
  },
  location: {
    textDecorationLine: "underline",
    cursor: "pointer",
  },
  row: {
    display: "flex",
    lineHeight: "30px",
  },
  left: {
    flex: 1,
  },
  divider: {
    height: "1px",
    background: palette.typography.black.neutral,
  },
}));

const UnallocatedLocationsPopover = ({
  unallocatedLocations,
  open,
  anchorEl,
  onClose,
}) => {
  const styles = useStyles();
  const dispatch = useDispatch();

  const goToLocation = (locationCode) => {
    onClose();
    dispatch(
      searchHandler({
        item: { locationCode },
        type: LOCATION,
      })
    );
  };

  return (
    <BaseSummaryPopover
      id={"unallocatedLocationsPopover"}
      title={"Unallocated Locations"}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      width={"250px"}
    >
      {unallocatedLocations.map(({ locationCode, name }) => (
        <View key={locationCode}>
          <View className={clsx(styles.row, styles.locationLine)}>
            <View className={styles.left}>
              <Typography
                className={styles.location}
                onClick={() => goToLocation(locationCode)}
              >
                {`${locationCode} - ${name}`}
              </Typography>
            </View>
          </View>
          <Divider className={styles.divider} />
        </View>
      ))}
    </BaseSummaryPopover>
  );
};

export default UnallocatedLocationsPopover;
